// extracted by mini-css-extract-plugin
export var activeFilterButton = "_so-c";
export var backButton = "_so-4";
export var backIcon = "_so-5";
export var chevronShortcut = "_so-6";
export var container = "_so-1";
export var editor = "_so-8";
export var editorWrapper = "_so-7";
export var prefix = "_so-2";
export var searchIcon = "_so-3";
export var suffix = "_so-9";
export var suffixContent = "_so-a";
export var suffixText = "_so-b";
export var wrapper = "_so-0";